import React from 'react'
import GoogleMapReact from 'google-map-react'
import { FaMapMarkerAlt } from 'react-icons/fa'

const MapMarker = ({ lat, lng }) => (
  <FaMapMarkerAlt size='42' color='#222' lat={lat} lng={lng} />
)

const GoogleMap = (content, { lat, lng, zoom }) => (
  <GoogleMapReact
    bootstrapURLKeys={{
      key: "AIzaSyAzEuG-vy7Ni3cBGsBN4N2HR2ZigkmZDck"
    }}
    defaultCenter={{
      lat: content.lat || lat,
      lng: content.lng || lng
    }}
    defaultZoom={content.zoom || zoom}
  >
    <MapMarker lat={content.lat || lat} lng={content.lng || lng} />
  </GoogleMapReact>
)

GoogleMap.defaultProps = {
  lat: 44.79,
  lng: -106.95,
  zoom: 1
}

export default GoogleMap
